import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const OperatorDetailPage = lazy(() =>
  import('@/pages/ads/operators/detail-page').then((m) => ({ default: m.OperatorDetailPage })),
);

export const Route = createFileRoute('/_app/ads/operators/$id')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:operators', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <OperatorDetailPage />
    </Suspense>
  ),
});
